import React from "react";

import { HeaderContext } from "../../context/headerContext";
import { OurStory } from "../../components/OurStory/OurStory";

type HeaderState = {
  color: string;
  showCategories: boolean;
  showSearch: boolean;
  showMainHeader: boolean;
  toggleFixed: boolean;
};

type HeaderContextValue = {
  headerState: HeaderState;
  setHeaderState: (state: HeaderState) => void;
};

const OurStoryPage: React.FC = () => {
  const { headerState, setHeaderState } = React.useContext(
    HeaderContext as unknown as React.Context<HeaderContextValue>
  );

  React.useEffect(() => {
    window.scrollTo(0, 0);

    setHeaderState({
      ...headerState,
      color: "#15222F",
      showCategories: true,
      showMainHeader: true,
      toggleFixed: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <OurStory />;
};

export default OurStoryPage;
